// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./Kendo/2020.2.617/styles/kendo.default.mobile.min.css
// module id = 949
// module chunks = 3